import { IMaskInput } from "react-imask"
import TextField from "component-lib/Base/components/TextField/TextField"

const MaskedTextField = ({
  mask = true,
  inputProps = {},
  InputProps = {},
  onAccept = () => {},
  prepare = (u) => u,
  commit = () => {},
  unmask = true,
  shouldDisable = false,
  /* mask={Number} specific props START */
  radix = `.`,
  padFractionalZeros = false,
  normalizeZeros = true,
  isPadAgreementFlow = false,
  ariaLabel = "",
  /* mask={Number} specific props END */
  ...otherProps
}) => {
  const inputPropsMask = {
    mask,
    onAccept,
    prepare,
    commit,
    unmask,
    radix,
    padFractionalZeros,
    normalizeZeros,
    ...inputProps,
    "aria-label": ariaLabel,
  }
  const InputPropsMask = {
    inputComponent: IMaskInput,
    ...InputProps,
  }

  return (
    <TextField
      data-testid="MaskedTextField"
      inputProps={inputPropsMask}
      /* eslint-disable-next-line react/jsx-no-duplicate-props */
      InputProps={InputPropsMask}
      helperText=" "
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...otherProps}
      disabled={isPadAgreementFlow || shouldDisable}
    />
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// MaskedTextField.propTypes = {
//   mask: PropTypes.string.isRequired,
//   inputProps: PropTypes.object,
//   InputProps: PropTypes.object,
//   onAccept: PropTypes.func,
//   prepare: PropTypes.func,
//   commit: PropTypes.func,
//   unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
//   radix: PropTypes.string,
//   padFractionalZeros: PropTypes.bool,
//   normalizeZeros: PropTypes.bool,
//   isPadAgreementFlow: PropTypes.bool,
//   ariaLabel: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// MaskedTextField.defaultProps = {
//   inputProps: {},
//   InputProps: {},
//   onAccept: () => {},
//   prepare: (u) => u,
//   commit: () => {},
//   unmask: true,
//   radix: `.`,
//   padFractionalZeros: false,
//   normalizeZeros: true,
//   isPadAgreementFlow: false,
//   ariaLabel: "",
// }

export default MaskedTextField
